import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from 'ps-components/Button/Button';
import { deleteRule } from '../Rules/RulesActions';

import './DeleteModal.scss';

class DeleteModal extends Component {
  static propTypes = {
    modal: PropTypes.object,
    actions: PropTypes.object
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      Object.keys(this.props.rules.selectedRule) &&
      this.props.rules.selectedRule.id !== nextProps.rules.selectedRule.id
    ) {
      return true;
    }
    return true;
  }

  onCancel = () => {
    const { history, actions } = this.props;
    history.goBack();
    actions.hideModal();
  };

  onDelete = () => {
    const { deleteRule, modal, history, actions } = this.props;
    const { rule } = modal.modalProps;

    deleteRule(rule.id);
    history.goBack();
    actions.hideModal();
  };

  render() {
    const { selectedRule } = this.props.rules;

    return (
      <div className="modal__delete">
        <div className="modal__delete-title">Delete Rule</div>
        <div className="modal__delete-notes">
          {selectedRule.name ? `Are you sure you want to delete "${selectedRule.name}"?` : null}
        </div>
        <div className="modal__delete-buttons">
          <a className="modal__delete-link" onClick={this.onCancel}>
            Cancel
          </a>
          <Button className="modal__delete-btn" onClick={this.onDelete}>
            Delete
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ dataCuts, rules, session }) => {
  return {
    rules
  };
};
export default connect(mapStateToProps, { deleteRule })(DeleteModal);
